document.addEventListener('DOMContentLoaded', function () {
  // COLOR DROPDOWNS
  const dropdowns = document.querySelectorAll('[data-color-dropdown]');
  dropdowns.forEach(dropdown => {
    const toggle = dropdown.querySelector('.color-dropdown-toggle');
    const options = dropdown.querySelector('.color-dropdown-options');
    const items = dropdown.querySelectorAll('.color-dropdown-option');
    const hiddenInput = dropdown.querySelector('input[name^="properties"]');
    const selectedLabel = dropdown.querySelector('.color-dropdown-selected');
    const swatchPreview = dropdown.querySelector('.color-swatch-preview');

    toggle.addEventListener('click', () => {
      const isOpen = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', String(!isOpen));
      dropdown.setAttribute('aria-expanded', String(!isOpen));
    });

    items.forEach(item => {
      item.addEventListener('click', () => {
        const value = item.dataset.value;
        const swatchColor = item.dataset.color;
        hiddenInput.value = value;
        selectedLabel.textContent = value;
        if (swatchPreview && swatchColor) swatchPreview.style.backgroundColor = swatchColor;
        items.forEach(i => i.setAttribute('aria-selected', 'false'));
        item.setAttribute('aria-selected', 'true');
        toggle.setAttribute('aria-expanded', 'false');
        dropdown.setAttribute('aria-expanded', 'false');
      });

      item.addEventListener('keydown', e => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          item.click();
        }
      });
    });

    document.addEventListener('click', e => {
      if (!dropdown.contains(e.target)) {
        toggle.setAttribute('aria-expanded', 'false');
        dropdown.setAttribute('aria-expanded', 'false');
      }
    });
  });

  // SHIPPING TYPE SELECTOR (Only handles showing download link)
  const shippingInputs = document.querySelectorAll('input[data-shipping-type]');
  const multiNote = document.getElementById('multi-shipping-note');

  if (!shippingInputs.length || !multiNote) return;

  shippingInputs.forEach(input => {
    input.addEventListener('change', () => {
      const isMulti = input.checked && input.value === 'Multiple Addresses';
      console.log('Shipping type changed:', input.value, '→ show file?', isMulti);
      multiNote.style.display = isMulti ? 'block' : 'none';
    });
  });
});
